// Inline SVG data URI to avoid cross-origin issues with mask-image
// Source: @watershed/icons/svg/Checkmark.svg
const CHECKMARK_SVG_DATA_URI = `data:image/svg+xml,${encodeURIComponent(
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.7071 5.29289C21.0976 5.68342 21.0976 6.31658 20.7071 6.70711L9.70711 17.7071C9.31658 18.0976 8.68342 18.0976 8.29289 17.7071L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929C3.68342 10.9024 4.31658 10.9024 4.70711 11.2929L9 15.5858L19.2929 5.29289C19.6834 4.90237 20.3166 4.90237 20.7071 5.29289Z" fill="currentColor"/></svg>'
)}`;

export const menuStyles = (options?: {
  width?: number | string;
  minWidth?: number | string;
  maxWidth?: number | string;
  maxHeight?: number | string;
  hasSections?: boolean;
}) => {
  const { width, minWidth, maxWidth, maxHeight, hasSections } = options ?? {};

  return {
    '& .MuiMenu-paper': {
      borderRadius: '10px',
      transition: 'opacity 200ms ease-in-out, transform 200ms ease-in-out',
      transformOrigin: 'top left',
      maxHeight,
    },
    '&. MuiList-root': { mt: 0 },
    '& .MuiMenu-list': {
      p: hasSections ? 0 : 0.5,
      minWidth: width ?? minWidth ?? '192px',
      maxWidth: width ?? maxWidth ?? '320px',
      display: 'flex',
      flexDirection: 'column',
      gap: 0.25,
      // Remove border from tooltipped items
      '> .MuiBox-root': {
        border: 0,
      },
    },
    '& .MuiMenuItem-root': {
      px: 1,
      py: 0.75,
      borderRadius: 1,
      border: 0,
      gap: 1,
      textWrap: 'balance',
    },
    '& .MuiMenuItem-root.Mui-selected': {
      color: 'primary.main',
      backgroundColor: 'cobalt10',
      // Add padding to the right to account for the checkmark icon
      pr: 4,
      '&::after': {
        content: '""',
        display: 'block',
        position: 'absolute',
        right: 12,
        top: '50%',
        transform: 'translateY(-50%)',
        width: 16,
        height: 16,
        backgroundColor: 'primary.main',
        maskImage: `url("${CHECKMARK_SVG_DATA_URI}")`,
        maskRepeat: 'no-repeat',
        maskSize: 'contain',
        pointerEvents: 'none',
      },
    },
  };
};
